//Page for edition user data

import React from 'react';
// reactstrap components
import { Card, CardHeader, CardBody, CardTitle } from 'reactstrap';
import { useTranslate } from 'react-translate';
import PatientListComponent from 'components/Patients/PatientListComponent';

const PatientList = () => {
  const t = useTranslate('patients');
  return (
    <>
      {/*<PanelHeader size="sm" /> */}
      <Card className="profile">
        <CardBody>
          <Card className="mb-0">
            <CardHeader>
              <CardTitle className="d-flex align-content-center">
                <div className="general-card-title-img text-primary mr-2">
                  <i className="icon-user-active" />
                </div>
                <div className="general-card-title text-primary">
                {t("title")}
                </div>
              </CardTitle>
            </CardHeader>

            <CardBody>
              <PatientListComponent />
            </CardBody>
          </Card>
        </CardBody>
      </Card>
    </>
  );
};

export default PatientList;